<template>
  <div class="image-uploader-stub">
    <input type="file" accept="image/*" @change="onChange" />
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  emits: ['input'],
  methods: {
    onChange (event) {
      const file = event.target.files?.[0]
      if (file) this.$emit('input', file)
    }
  }
}
</script>
